export default __webpack_public_path__ + "static/media/photo--sm--kickoff5.66e6fe91.jpg";